module.exports = __webpack_public_path__ + "static/img/u14.3252b0f7.svg";